module.exports = "<div class=\"main\" [class.login]='isLogin'>\r\n  <div class=\"overlay animate-opacity\" [attr.id]=\"overlayID\" (click)=\"toggleMainMenu()\"></div>\r\n  <ng-content></ng-content>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// C:/www/onetouchSuperAdmin/src/app/core/main/main.component.html
// module id = ../../../../../src/app/core/main/main.component.html
// module chunks = 2